<template lang="pug">
    div.contain#register
      div.logo_title
        p.title {{$t('Login.register.title')}}
      km-form(label-width="130px" :models="$data" ref="form" :rules="rules")
        km-form-item(:label="$t('Login.register.phoneNumber')" prop="phone" required=true ref="phone")
          km-input.warp_input(v-model="phone" :placeholder="$t('Login.register.phoneNumber')")
        km-form-item(:label="$t('Login.register.captcha')" prop="captcha" required=true ref="captcha")
          km-input.warp_input.ic(:placeholder="$t('Login.register.captchaPh')" v-model="captcha")
          img.iccode(:src="imgUrl" ref="icCode")
          a#change(@click="changeCode") {{$t('Login.register.changeOne')}}
        km-form-item(:label="$t('Login.register.phoneCode')" prop="phoneCode" required=true )
          div
            km-input.warp_input(:placeholder="$t('Login.register.phoneCodePh')" :showClearIcon="false" v-model="phoneCode")
            a#phoneCode(href="#" @click="getVerifyCode" ref="code") {{$t('Login.register.getCode')}}
        km-form-item(:label="$t('Login.register.password')" required=true prop="password" ref="password")
          km-input.warp_input(:placeholder="$t('Login.register.passwordPh')" v-model="password")
        km-form-item(:label="$t('Login.register.certifyPassword')" required=true prop="passwordOnceMore" ref="passwordOnceMore")
          km-input.warp_input(:placeholder="$t('Login.register.newPasswordPh')" v-model="passwordOnceMore")
        km-form-item(required=true prop="selected" ref="selected")
          div.f16.greyc.checkbox
          i.operation_icon(@click="toggle" :class="{active: selected}")
          span {{$t('Login.register.accept')}}
          a.f14.green(href="/web/statics/qsnxy-kami.html" target="_blank") {{$t('Login.register.agreement')}}
          a.f14.green(href="/web/statics/cancel-kami.html" target="_blank") 《用户注销协议》
          a.f14.green(href='/static/page/private.html' target='_blank') 《隐私政策》
        km-form-item
          p.errTips.red(v-text="errText")
        km-form-item
          km-button(name="register" size="max" @click="gotoPerfect" :isBack="true") {{$t('Login.register.rMsg')}}
        km-form-item
          div.goto.f14.grey6 {{$t('Login.register.haveOne')}}
            span#goLogin.f14.green(@click="gotoLogin") {{$t('Login.register.rightNow')}}
</template>
<script>
import { sendMessage, validate } from '@/api'
import cryptoJs from 'crypto-js'
const registerInfo = {}
export default {
  name: 'register',
  data() {
    return {
      phone: '', // 手机号
      phoneCode: '', // 手机验证码
      captcha: '', // 图形验证码
      password: '',
      passwordOnceMore: '',
      selected: false,
      showPerfect: false,
      errText: '',
      imgUrl: '',
      wait60: false,
      errInput: {
        phone: false,
        verify: false,
        Pwd: false,
        Pwd2: false,
        phoneCode: false
      },
      timeId: '',
      rules: {
        phone: [
          { type: 'string', pattern: /1[0-9]{10}/, len: 11, required: true, trigger: 'blur', message: this.$t('Login.register.error.phoneError') }
        ],
        captcha: [{
          required: true,
          pattern: /\w{4}/,
          trigger: 'blur',
          message: this.$t('Login.register.error.captchaError')
        }],
        phoneCode: [
          {
            required: true,
            pattern: /\w{4}/,
            message: this.$t('Login.register.error.phoneCodeError')
          }
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, cb) => {
              if (value && !value.match(/^[\u4e00-\u9fa5]+$/gi)) {
                cb()
              } else {
                cb('密码不能为空或包含中文')
              }
            }
          },
          {
            trigger: 'blur',
            min: 1,
            max: 16,
            message: '密码长度为1-16位'
          }
        ],
        passwordOnceMore: [
          {
            required: true,
            validator: (rule, value, cb) => {
              if (value && value === this.password) {
                cb()
              } else if (!value) {
                cb(this.$t('Login.register.error.pwdEmpty'))
              } else {
                cb(this.$t('Login.register.error.pwdInconsistent'))
              }
            },
            trigger: 'blur',
          }
        ],
        selected: [
          {
            validator: (rule, value, cb) => {
              if (value) {
                cb()
              } else {
                cb('请先勾选')
              }
            },
            message: '请先勾选'
          }
        ]
      }
    }
  },
  methods: {
    gotoPerfect() {
      this.$refs.form.validate().then(() => {
        this.collectInfo()
        validate({...registerInfo, password: cryptoJs.MD5(registerInfo.password).toString(), passwordConfirm: cryptoJs.MD5(registerInfo.passwordConfirm).toString()}).then((res) => {
          if (res.status === 1) {
            this.$emit('perfectInfo', {
              type: 'register',
              ...registerInfo
            })
          } else {
            this.errText = res.info
            this.$alert(res.info)
          }
        })
      }).catch(() => { })
    },
    toggle() {
      this.selected = !this.selected
    },
    gotoLogin() {
      this.$emit('disappear')
    },
    collectInfo() {
      registerInfo.phone = this.phone
      registerInfo.captcha = this.phoneCode
      registerInfo.password = this.password
      registerInfo.passwordConfirm = this.passwordOnceMore
    },
    phoneValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.phone.validate('', (a, b) => {
          if (a) {
            reject(new Error('无手机号'))
          } else {
            resolve()
          }
        })
      })
    },
    captchaValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.captcha.validate('', (a, b) => {
          if (a) {
            reject(new Error('无图形验证码'))
          } else {
            resolve()
          }
        })
      })
    },
    async getVerifyCode() {
      if (this.wait60) return false
      await this.phoneValidate()
      await this.captchaValidate()
      this.errText = ''
      this.wait60 = true
      let cd = 60
      let obj = this.$refs.code
      this.timeId = setInterval(() => {
        if (cd === 0) {
          clearInterval(this.timeId)
          obj.innerHTML = '获取验证码'
          obj.style.color = '#21bd73'
          this.wait60 = false
        } else {
          cd--
          obj.innerHTML = cd + '秒后重新获取'
          obj.style.color = '#ccc'
        }
      }, 1000)
      sendMessage({
        verifyCode: this.captcha,
        phone: this.phone
      }).then((res) => {
        if (res.status !== 1) {
          clearInterval(this.timeId)
          this.$refs.code.innerHTML = '获取验证码'
          this.wait60 = false
          this.errText = res.info
          this.changeCode()
        }
      })
    },
    changeCode() {
      this.imgUrl = localStorage.getItem('zyUrl') + '/api/FrontendStudents/getVerifyCode?yys=' + (+new Date())
    }
  },
  mounted() {
    this.changeCode()
  },
  beforeDestroy() {
    clearInterval(this.timeId)
  }
}
</script>
<style lang="less">
@image-url: '../../../assets/images';
#register {
  margin-top: -68px;
  margin-left: -66px;
  .warp_input {
    height: 40px;
    width: 330px;
  }
  .logo_title {
    text-align: center;
    p {
      padding-left: 66px;
      margin: 20px 0;
      font-size: 24px;
      color: #666;
    }
  }
  .operation_icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 10px;
    background-image: url('@{image-url}/icon_common.png');
    background-position: 0px 0;
    cursor: pointer;
    &.active {
      background-image: url('@{image-url}/icon_common.png');
      background-position: -16px 0;
    }
  }
  .iccode {
    width: 100px;
  }
  #close {
    position: fixed;
    right: 70px;
    top: 50px;
    cursor: pointer;
    z-index: 999;
  }
  a#change {
    color: #21bd73;
    font-size: 16px;
    line-height: 40px;
    margin-left: 10px;
    text-decoration: underline;
  }
  .ic {
    width: 164px;
    margin-right: 6px;
  }
  #phoneCode {
    color: #21bd73;
    font-size: 16px;
    line-height: 40px;
    text-decoration: none;
    position: absolute;
    right: 10px;
    top: 0;
  }
  .goto {
    margin-left: 110px;
    #goLogin {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/register.vue